import type {
  NewVersionFormValues,
  NewVersionPayload,
  UploadDocumentFormValues,
  UploadDocumentPayload,
} from "./documentWorkspace.types";

export const DOCUMENT_WORKSPACE_DATASET_TYPE = "study-documents";

export function buildUploadPayload(
  values: UploadDocumentFormValues,
): UploadDocumentPayload {
  return {
    title: values.title,
    document_class: values.documentClass,
    rollout_scope: values.rolloutScope,
    role_access: values.roleAccess,
    amendment_label: values.amendmentLabel ?? undefined,
    effective_from: values.effectiveFrom ?? undefined,
    note: values.note ?? undefined,
    file: values.file,
  };
}

export function buildNewVersionPayload(
  values: NewVersionFormValues,
): NewVersionPayload {
  return {
    amendment_label: values.amendmentLabel ?? undefined,
    effective_from: values.effectiveFrom ?? undefined,
    note: values.note ?? undefined,
    file: values.file,
  };
}

export function formatFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return "—";
  if (bytes < 1024) return `${bytes} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let value = bytes / 1024;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  return `${value.toFixed(value >= 10 ? 0 : 1)} ${units[unitIndex]}`;
}
